import {Type} from 'class-transformer';
import {ApprovalStatus, serializeType, Transaction} from '@app/shared';


export class ActionMessage {
  htmlBody: string;
  id: number;
  sentBy: string;
  @Type(serializeType(Date)) sentOn: Date;
  sentTo;
  string;
  subject: string;
  type: string;
  version: number;
}

export class TxnTypeDetail {
  approvable: boolean;
  approvalPolicyId: number;
  approvalPolicyName: string;
  className: string;
  delegatable: boolean;
  description: string;
  detailTemplate: string;
  @Type(serializeType(Date)) effectiveOn: Date;
  escalatable: boolean;
  id: number;
  name: string;
  orgId: number;
  statusPolicyId: number;
  statusPolicyName: string;
  structId: number;
  version: number;
}

export class TxnStructure {
  id: number;
  name: string;
  description: string;
  orgId: number;
  parentId: number;
  version: number;
}

export class Status {
  id: number;
  name: string;
  description: string;
  orgId: number;
  subType: number;
  version: number;
}

export class SearchOption {
  @Type(serializeType(TxnStructure)) txnStructure: TxnStructure;
  txnType: string;
  @Type(serializeType(Status)) status: Status;
  refId: number;
  submittedDate: string;
  dueDate: string;
  subtype?: string;
  title?: string;
  assignedById?: number;
  submittedFor: string;
  submittedBy: string;
}

export class UserSummary {
  approverName: string;
  cellPhone: string;
  firstName: string;
  fullName: string;
  id: number;
  lastName: string;
  obsDepth: number;
  workEmail: string;
}

export class WorklistCount {
  submitted: number = 0;
  inProgress: number = 0;
  final: number = 0;
  rejected: number = 0;
  approved: number = 0;
}

export class WorkItem {
  actionMessage: ActionMessage;
  actionOn: string;
  approvalPolicyId: number;
  @Type(serializeType(ApprovalStatus)) approvals: ApprovalStatus[];
  approvedById: number;
  assignedToId: number;
  @Type(serializeType(UserSummary)) assignedToSummary: UserSummary;
  correlationKey: string;
  currentApproval: string;
  currentStatus: string;
  delegatable: boolean;
  detail: string;
  dueDateOn: string;   // stored as Date in the DB => requires UTC conversion when displaying
  errorCodes: string;
  escalatable: boolean;
  escalatedOn: string;
  id: number;
  refId: number;
  txnNumber: string;
  statusPolicyId: number;
  submittedById: number;
  @Type(serializeType(UserSummary)) submittedBySummary: UserSummary;
  @Type(serializeType(Date)) submittedOn: Date; // stored as DateTime in the DB => no UTC conversion when displaying
  submittedForId: number;
  @Type(serializeType(UserSummary)) submittedForSummary: UserSummary;
  @Type(serializeType(TxnTypeDetail)) txnType: TxnTypeDetail;
  pdfTemplateId: number;
  txnTypeCategory: string;
  txnTypeId: number;
  transaction: Transaction;
  userFriendlyCurrentStatus: string;
  version: number;
  workgroupId: number;
}

export class NotificationMessage {
  id: number;
  htmlBody: string;
  subject: string;
  type: string;
  @Type(serializeType(Date)) sentOn: Date;
  sentBy: string;
  sentTo: string;
  workitemId: number;
}

export class Notification {
  id: number;
  message: NotificationMessage;
}
